import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'

import DataMenu from './DataMenu'
import ToolsMenu from './ToolsMenu'
import ViewsMenu from './ViewsMenu'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'


export default class CommerceUserToolbar extends Component {

    state = {}

    componentDidUpdate = (prevProps) => {

    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    render() {
        return (
            <div className='w-100'>
                <div className='w-100 flexcb'>
                    <button className={"br-5 flexc px-3 py-1 dark-blur-hover"} ref={(el) => (this.file = el)} onClick={() => { this.fileView.showView(); }} >
                        <img className='mrd-2 flexcc' width={14} src={'/assets/icons/target.svg'} alt="" />
                        <p className='font-size-14 ' style={{ color: '#fff', }}>{checkTranslation("{{lang}}Categories")}</p>
                    </button>
                    <div className=' navbar-search2 py-1 px-2 br-30' style={{ width: '200px' }}>
                        <div className='d-flex flexcb'>
                            <input className="w-100 px-1" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in Commerce`)} style={{ backgroundColor: 'transparent', }} />
                            <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                        </div>
                    </div>
                </div>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.fileView = el)} nodeRef={this.file} xOffset={this.props.language == "fa" ? 210 : -10} bottomOffset={0} topOffset={0} maxWidth={260}  >
                    <div className="bg-white br-10 p-1 shadow-3 sc-gray2">
                        <StagesManager ref={(el) => (this.stageManager = el)} height={"100%"} fast={true}   >
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={"ّfile"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}   >
                                <div className="mb-2">
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}All", sub: false, icon: "/assets/icons/note/file/new.svg" }} />
                                </div>
                                <div className="py-2" style={{ borderTop: "1px solid #eee" }}  >
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("iPhone")} data={{ title: "{{lang}}iPhone", sub: true, icon: "/assets/icons/note/file/share.svg" }} />
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("Macbook")} data={{ title: "{{lang}}Macbook", sub: false, icon: "/assets/icons/note/file/email.svg" }} />
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("airpod")} data={{ title: "{{lang}}airpod", sub: false, icon: "/assets/icons/note/file/download.svg" }} />
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("iPad")} data={{ title: "{{lang}}iPad", sub: false, icon: "/assets/icons/note/file/download.svg" }} />
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("iMac")} data={{ title: "{{lang}}iMac", sub: false, icon: "/assets/icons/note/file/download.svg" }} />
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("iPod")} data={{ title: "{{lang}}iPod", sub: false, icon: "/assets/icons/note/file/download.svg" }} />
                                </div>
                            </div>
                            <div className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }} width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={"iPhone"}   >
                                <div className="">
                                    <div className="pb-2">
                                        <button className="flexc w-100 hover-gray p-2 br-10" onClick={this.lastPage}  >
                                            <img width={18} src="/assets/icons/arrow-left-gray.svg" className="rtl-button" />
                                            <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {translate("iPhone")}  </p>
                                        </button>
                                    </div>
                                    <div className="pt-2" style={{ borderTop: "1px solid #eee" }}   >
                                        <IntractionActionsList language={this.props.language} data={{ title: "iphone 14", icon: "/assets/icons/note/file/new.svg" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "iPhone 13", icon: "/assets/icons/note/file/open.svg" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "iPhone 12", icon: "/assets/icons/note/file/open.svg" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "iPhone SE", icon: "/assets/icons/note/file/open.svg" }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </div>
        )
    }
}
